import { render, staticRenderFns } from "./OverviewTextAndImage.vue?vue&type=template&id=acc9f96c&scoped=true&"
import script from "./OverviewTextAndImage.vue?vue&type=script&lang=ts&"
export * from "./OverviewTextAndImage.vue?vue&type=script&lang=ts&"
import style0 from "./OverviewTextAndImage.vue?vue&type=style&index=0&id=acc9f96c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc9f96c",
  null
  
)

export default component.exports